const Event = {
  over_group: "The balance entity stores usages & costs on the subscriber level. There is one main balance per billing cycle per subscriber which keeps track of the services & products included in the subscriber's plan, as well as exceeding usages. Multiple balances can exist at the same time, in case services are purchased by the subscriber.",
};

export default Event;